export default __webpack_public_path__ + "static/media/KakaoTalkSpeechBubbleIcon.ad44341f.png";